import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ScannerApp from './ScannerApp';
import './styles/globals.css';
import './styles/brutalist.css';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScannerApp />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
